export default __webpack_public_path__ + "static/media/background.eb89dfbe.png";